import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import { AdTestingQuestionModelTypes, IAdTestingQuestionModelState, IAdTestingResponseValidation } from './types'

const AdTestingQuestionModel: IQuestionModelConstructor<AdTestingQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<AdTestingQuestionModelTypes, IAdTestingQuestionModelState>({
    questionType: QuestionType.AD_TESTING,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IAdTestingQuestionModelState) {
  return [response.response]
}

function initState(state: IAdTestingQuestionModelState): IAdTestingQuestionModelState {
  state.response = { response: { id: state.questionSchema.id } }
  return state
}

function validateResponse({ response, questionSchema }: IAdTestingQuestionModelState): IAdTestingResponseValidation {
  return {
    valid: questionSchema.video || questionSchema.image ? response.viewed : true
  }
}

export default AdTestingQuestionModel
